import { signal } from '@preact/signals';
import { PromoBanner } from '../PromoBanner';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

const mockLoggedIn = signal(true);

export const showcase: ComponentShowcase = {
  name: 'PromoBanner',
  category: '💬 Chat',
  description: 'Modal de banner promocional pós-login com suporte a countdown e banner normal.',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ padding: 16, fontSize: 13, color: T.textMuted }}>
      PromoBanner é um modal fullscreen — renderiza apenas quando há banners ativos da API.
      <br />Suporta: countdown com timer, banner com imagem/vídeo, slots restantes.
    </div>
  ),
};
